<template>
  <div class="login-box">
    <div class="content-box">
      <div class="img-bg">
        <img
          style="height: 100%; width: 100%"
          src="@/assets/images/notfoundBg.png"
          alt="nofound"
        />
        <img
          class="cuise-img"
          src="@/assets/images/cuiseNot.png"
          alt="nofound"
        />
      </div>
      <div class="back-btn">
        <i class="el-icon-back" ></i>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item >
            <span style="cursor:default;font-weight: 600;color:#09CA6A;">Login</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div class="bg-box"></div>

    <div class="form-box" >
      <div class="top-box"> 
        <a @click="preTab" class="back" v-if="currentTab==1 || currentTab==2">
          <i class="el-icon-back"></i>
        </a>
        <span style="flex: 1;" ></span>
        <a @click="goBack" class="close">
          <i class="el-icon-close"></i>
        </a>
      </div>

      <div class="slide-box">
        <!-- 登录表单 -->
        <div key="0" style="width:100%;padding: 0 30px;" v-if="currentTab==0" >
          <LoginForm 
            :fromPage="'login'"
            @loginSuccess="handleLoginSuccess"
            @smsSuccess="handleSmsSuccess"
            @gotCode="handleGotCode"
          />
        </div>

        <!-- 短信验证码输入 -->
        <div key="1" v-if="currentTab==1">
          <div class="phone-box">
            <h2>Enter 4 digit code</h2>
            <p>Your code was sent to <span class="under-line">{{ form.code }} {{ form.phone }}</span></p>
            <div class="ver-code">
              <input  
                v-model="form.verCode" 
                name="" 
                type="digital" 
                @focus="inputFocus=true" 
                @blur="inputFocus=false" 
                placeholder="Verification Code"
                @keyup="form.verCode=form.verCode.substring(0,4)" 
                autofocus 
                v-if="currentTab==1"
              >
            </div>
            <div :class="['resend-btn',{'disabled':!canGetCode}]" @click="showCaptcha(true)" >{{ sendPhonecode }}</div>
          
            <div 
              :class="['sign-btn','flex-row-center',{'disable-btn':!cantLogin || confirmLoading}]" 
              @click="login"
            >
              <i v-if="confirmLoading" class="el-icon-loading" style="margin-right: 8px;"></i>
              {{ confirmLoading ? 'Verifying...' : 'Confirm' }}
            </div>
          </div>
        </div>
      </div>

      <!-- 验证token - 弹层形式显示 -->
      <div v-if="showCloudflare" class="cloudflare-modal">
        <div class="cloudflare-overlay" @click="closeCloudflare"></div>
        <div class="cloudflare-content">
          <div class="cloudflare-header">
            <h3>Security Verification</h3>
            <button class="close-btn" @click="closeCloudflare">
              <i class="el-icon-close"></i>
            </button>
          </div>
          <CloudflareVerify 
            style="padding: 20px;" 
            ref="cloudflare"
            @token-received="onTokenReceived"
          ></CloudflareVerify>
        </div>
      </div>

      <!-- 忘记密码弹窗 -->
      <ForgotPassword 
        v-if="showForgotPasswordModal"
        @close="closeForgotPassword"
      ></ForgotPassword>

    </div>

    <!-- 验证码滑块模块 -->
    <Verify @success="sendcodeMsg"
      :mode="'pop'"
      :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    ></Verify>

  </div>
</template>

<script>
/* eslint-disable */
import { postGateway } from '@/request';
import PhoneBtn from '@/components/PhoneBtn.vue';
import Verify from '@/components/Verifition/Verify';
import LoginForm from '@/components/LoginForm.vue';
import bus from '@/utils/bus.js';
import CloudflareVerify from '@/components/CloudFlareVerify.vue';
import ForgotPassword from '@/components/ForgotPassword.vue';
import GoogleLogin from '@/components/GoogleLogin.vue';
import { getMerchantConfig } from '@/config/merchantConfig';

export default {
  metaInfo: {
    
  },
  name: "Login",
  components: {
    PhoneBtn,
    Verify,
    LoginForm,
    CloudflareVerify,
    ForgotPassword,
    GoogleLogin
  },
  data() {
    return {
      MerchantConfig: {},
      inputFocus: false,
      currentTab: 0, // 默认显示登录方式选择
      confirmLoading: false, // confirm按钮loading状态
      showCloudflare: false, // 是否显示Cloudflare验证
      showForgotPasswordModal: false, // 显示忘记密码弹窗
      form: {
        phone: '',
        code: (this.$isUk ? '+44' : '+353'),
        verCode: '', // 手机验证码
        password: '', // 密码
        email: '', // 邮箱
      }
    }
  },
  computed: {
    cantLogin() {
      return this.form.verCode.length === 4
    }
  },
  async created() {
    this.MerchantConfig = await getMerchantConfig();
  },
  mounted() {
  },
  beforeRouteEnter(to, from, next){
    // lastPath = from.fullPath;
    next();
  },
  methods: {
    // 处理LoginForm的登录成功事件
    handleLoginSuccess(data) {
      this.$nextTick(() => {
        // 优先从路由查询参数获取跳转路径
        const redirectPath = this.$route.query.redirect || this.$route.query.returnUrl;
        if (redirectPath) {
          this.$router.replace(redirectPath);
        } else {
          // 如果没有指定跳转路径，返回上一页
          if (window.history.length > 2) {
            this.$router.go(-1);
          } else {
            this.$router.replace(this.MerchantConfig.merchantMenuUrl || '/');
          }
        }
        this.$forceUpdate();
      });
    },
    
    // 处理LoginForm的短信发送成功事件
    handleSmsSuccess() {
      if (this.currentTab < 1) {
        this.nextTab();
      }
    },
    
    // 处理LoginForm的gotCode事件
    handleGotCode() {
      this.nextTab();
    },
    
    // 发送短信验证码
    sendcodeMsg(captchaVerification) {
      // 这个方法现在由LoginForm组件处理
      console.log('sendcodeMsg called with:', captchaVerification);
    },
    
    // 关闭 Cloudflare 弹层
    closeCloudflare() {
      this.showCloudflare = false;
      this.resetCode();
    },
    
    // 显示忘记密码弹窗
    showForgotPassword() {
      this.showForgotPasswordModal = true;
    },
    
    // 关闭忘记密码弹窗
    closeForgotPassword() {
      this.showForgotPasswordModal = false;
    },
    
    // 跳转到注册页面
    goToSignup() {
      this.$router.push({
        path: '/signup',
        query: { from: 'login' }
      });
    },
    
    // 重置验证码
    resetCode() {
      // 重置验证码相关状态
      console.log('Reset code called');
    },
    gotCode() {
      if(!this.form.phone.trim()) {
        this.$message({
            message: 'Please enter phone number',
            type: 'warning',
            offset: 50
        })
        return
      }
      if (this.form.phone.indexOf(44) === 0) {
        this.$message({
          message: "Without the '44' country code.",
          type: "warning",
          offset: 50
        });
        return;
      }

      this.nextTab()
    },
    changTab(index) {
      this.currentTab = index;
    },
    goBack() {
      this.$router.go(-1)
    },
    preTab() {
      // this.$refs.carousel.setActiveItem(0);
      this.currentTab = 0;
    },
    nextTab() {
      this.currentTab = 1;
      // this.$refs.carousel.setActiveItem(1);
    },
    gotoPrivate() {
      this.$router.push("/Privacy-Policy");
    },
    login() {
      this.confirmLoading = true;
      let { code, phone } = this.form;
      console.log(code, phone)
   
      postGateway({
        url: '/sys/client/clientLogin',
        method: 'POST',
        data: {
          phone: code + phone,
          code: this.form.verCode,
          type: 'web'
        }
      }).then(res=>{
        this.confirmLoading = false;
        if(res.data.token) {
          let { token, refreshToken, clientId } = res.data;
          localStorage.setItem('token',token);
          localStorage.setItem('refreshToken',refreshToken);
          localStorage.setItem('clientId', clientId);
          localStorage.setItem("aeClient", clientId);
          bus.$emit('login') // 通知header登陆了
          
          // 优先从路由查询参数获取跳转路径
          const redirectPath = this.$route.query.redirect || this.$route.query.returnUrl;
          if (redirectPath) {
            this.$router.replace(redirectPath);
          } else {
            // 如果没有指定跳转路径，返回上一页
            if (window.history.length > 1) {
              this.$router.go(-1);
            } else {
              // 如果无法返回上一页，则使用本地配置的merchantMenuUrl
              if (this.MerchantConfig && this.MerchantConfig.merchantMenuUrl) {
                this.$router.replace(this.MerchantConfig.merchantMenuUrl);
              } else {
                // 最后才跳转到首页
                location.href = '/';
              }
            }
          }
        }
        console.log(res,'登录回调')
      })
      .catch((err)=>{
        this.confirmLoading = false;
        this.$message.error(err.msg)
      })
    }
  }
};
</script>

<style lang="scss" scoped>
$mainColor: #aa0bc0;
$greenColor: #26d07c;
$yellowColor: #ffa132;
.login-box {
  min-height: 120vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .bg-box {
    flex: 1;
    background-image: url("../assets/images/login_bg.png");
    background-size: cover;
    background-position: center;
  }
  .back-btn {
    position: relative;
    background: #0A191E;;
    height: 36px;
    border-radius: 18px;
    padding: 0 20px;
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin: 30px 6% 0;
    .el-icon-back {
        color: #C2F93A;
        font-size: 22px;
        margin-right: 10px;
    }
    :deep(.el-breadcrumb__inner) {
        color: #fff;
    }
    :deep(.el-breadcrumb__separator) {
        color: #fff;
    }
  }

  .content-box {
    position: relative;
    width: 100%;
    height: 420px;
    .img-bg {
      position: absolute;
      z-index: 0;
      height: 420px;
      width: 100%;
    }

    .cuise-img {
      height: 259px;
      width: 370px;
      position: absolute;
      z-index: 1;
      right: 6%;
      top: 0px;
    }
  } 
  

  .form-box {
    width: 620px;
    min-height: 480px;
    background: #fff;
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 16px;
    padding: 0 40px 20px;
    position: absolute;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);

    h2 {
      font-weight: 800;
      color: #000;
      font-size: 35px;
      text-align: center;
      margin-top: 0;
      margin-bottom: 8px;
    }
    p {
      font-size: 16px;
      text-align: center;
      margin: 0;
      color: #111;
      .under-line {
        text-decoration: underline;
        margin: 0;
        cursor: pointer;
        color: #2885e2;
      }
    }

    .input-box {
      margin-top: 18px;
      display: flex;
      align-items: center;

      .area-box {
        height: 56px;
        width: 114px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        margin-right: 10px;
        border-radius: 12px;
      }
      .input {
        height: 56px;
        flex: 1;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        padding-left: 20px;
        font-size: 20px;
        font-weight: 600;
        &::placeholder {
          font-weight: 500;
        }
      }
      .shadow-box {
        flex: 1;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        position: relative;
        
        &.full-width {
          flex: 1;
          margin-right: 0;
        }
        
        input {
          height: 56px;
          width: 100%;
          border: none;
          outline: none;
          padding-left: 20px;
          padding-right: 50px;
          font-size: 20px;
          font-weight: 600;
          background: transparent;
          &::placeholder {
            font-weight: 500;
          }
        }
        
        .password-toggle {
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          color: #999;
          font-size: 18px;
          &:hover {
            color: #666;
          }
        }
      }
    }

    // 登录方式选择器样式
    .login-method-selector {
      display: flex;
      margin: 20px 0;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      
      .method-option {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px 20px;
        background: #f8f9fa;
        cursor: pointer;
        transition: all 0.3s ease;
        border-right: 1px solid #e9ecef;
        
        &:last-child {
          border-right: none;
        }
        
        i {
          margin-right: 8px;
          font-size: 18px;
          color: #666;
        }
        
        span {
          font-size: 16px;
          font-weight: 500;
          color: #666;
        }
        
        &.active {
          background: #09CA6A;
          color: white;
          
          i, span {
            color: white;
          }
        }
        
        &:hover:not(.active) {
          background: #e9ecef;
        }
      }
    }

    // 账号类型选择器样式
    .account-type-selector {
      display: flex;
      margin: 10px 0;
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
      max-width: 200px;
      margin-left: auto;
      margin-right: auto;
      border: 1px solid #e0e0e0;
      
      .type-option {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 10px;
        background: #ffffff;
        cursor: pointer;
        transition: all 0.2s ease;
        border-right: 1px solid #e0e0e0;
        
        &:last-child {
          border-right: none;
        }
        
        i {
          margin-right: 4px;
          font-size: 12px;
          color: #888;
        }
        
        span {
          font-size: 12px;
          font-weight: 400;
          color: #666;
        }
        
        &.active {
          background: #f0f8ff;
          border-color: #4a90e2;
          
          i, span {
            color: #4a90e2;
          }
        }
        
        &:hover:not(.active) {
          background: #f8f9fa;
        }
      }
    }

    .check-box {
      margin-top: 20px;
      display: flex;
      font-size: 18px;
      // padding-left: 126px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    
      :deep(.el-checkbox__inner) {
        background-color: #DCDFE6;
      }
      :deep(.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
        background-color: #09CA6A;
        border-color: #09CA6A;
      }
      :deep(.el-checkbox__inner) {
        transform: scale(1.4);
      }
      span {
        margin-left: 15px;
        cursor: pointer;
      }
      p {
        margin-top: 10px;
        display: block;
        font-size: 14px;
        line-height: 20px;
        color: #474747;
        text-align: left;
        .under-line {
          text-decoration: underline;
          margin: 0;
          cursor: pointer;
          color: #2885e2;
        }
      }
    }
    @keyframes shakingAnimation {
			0% {
				transform: translateX(-3%); 
				color: red;
			}
			10% {
				transform: translateX(63); 
				color: red;
			}
			20% {
				transform: translateX(-2%); 
				color: red;
			}
			30% {
				transform: translateX(2%); 
				color: red;
			}
			40% {
				transform: translateX(-1%); 
				color: red;
			}
			50% {
				transform: translateX(1%); 
			}
		}
    .shaking {
			color: rgb(199, 12, 12);
			transform: translateX(0); 
			animation: shakingAnimation 1s ease-in-out forwards;
		}
    .sign-btn {
      margin: 20px auto 5px;
      height: 58px;
      width: 240px;
      background-color: #09CA6A;
      color: #fff;
      font-size: 16px;
      letter-spacing: 1px;
      font-weight: 600;
      border-radius: 29px;
      box-shadow: 0 4px 12px rgba(9, 202, 106, 0.3);
      transition: all .3s ease;
      cursor: pointer;
      border: none;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: #0fda74;
        box-shadow: 0 6px 20px rgba(9, 202, 106, 0.4);
        transform: translateY(-2px);
      }
      &:active {
        transform: translateY(0);
      }
    }
    .being-send {
      height: 28px;
      font-size: 15px;
      margin: 10px auto 0;
      text-decoration: underline;
      cursor: pointer;
      text-align: center;
      display: block;
      &:active {
        color: #6f7577;
      }
    }
    
    // 底部链接容器
    .bottom-links-container {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;
    }
    
    .forgot-password-link {
      font-size: 14px;
      text-decoration: underline;
      cursor: pointer;
      color: #2885e2;
      transition: color 0.3s ease;
      
      &:hover {
        color: #1a6bb8;
      }
      
      &:active {
        color: #0f4a7a;
      }
    }
    
    .signup-link-container {
      text-align: center;
      font-size: 14px;
      color: #666;
      
      .signup-link {
        color: #d22f21;
        font-weight: bold;
        cursor: pointer;
        text-decoration: underline;
        margin-left: 5px;
        
        &:hover {
          color: #b01e1a;
        }
      }
    }
    
    // Google登录区域样式
    .google-login-section {
      margin-top: 20px;
      width: 100%;
      
      .divider {
        display: flex;
        align-items: center;
        margin: 20px 0;
        
        &::before,
        &::after {
          content: '';
          flex: 1;
          height: 1px;
          background: #e0e0e0;
        }
        
        span {
          padding: 0 15px;
          color: #999;
          font-size: 14px;
          background: #fff;
        }
      }
    }
    .disable-btn {
      background-color: #999;
      &:hover {
        background-color: #999;
        box-shadow: 0px 5px 10px #6f7577;
      }
    }
    .ver-code {
      margin: 30px auto 20px;
      display: flex;
      position: relative;
      width: 400px;
      overflow: visible;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
      justify-content: center;
      background: #fff;

      input {
        height: 58px;
        z-index: 10;
        font-size: 30px;
        width: 400px;
        background-color: transparent;
        box-sizing: border-box;
        border-radius: 12px;
        letter-spacing: 40px;
        text-align: center;
        font-weight: 600;
        border: none;
        outline: none;
        padding: 0 20px;

        &::placeholder {
          letter-spacing: normal;
          font-weight: 400;
          color: #c6c8cb;
          font-size: 25px;
        }
      }
      .mask-box {
        display: none;
        // display: flex;
        // justify-content: center;
        // width: 400px;
        .font-box {
          height: 65px;
          min-width: 68px;
          border-radius: 4px;
          margin-right: 30px;
          box-shadow: 0px 3px 6px #8F9698;
          background-color: #fff;
          font-size: 30px;
          color: #000;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          position: relative;

          .ol-line {
            height: 40px;
            width: 2px;
            border-radius: 1px;
            background-color: #000;
            animation: breath 1.2s ease-in-out infinite  alternate forwards;
            position: absolute;
            left: 22%;
            top: 50%;
            transform: translateY(-50%);
            z-index: 20;
          }
        }
      }
    }

    @keyframes breath {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    .top-box {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 20px;

      i {
        font-size: 26px;
        
        color: #000;
        cursor: pointer;
        transition: all ease-in .2s;
        text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);
        &:hover {
          color: $mainColor;
        }
      }
      .back {
        position: relative;
        left: -30px;
      }
      .close {
        position: relative;
        right: -40px;
      }
    }

    .slide-box {
      position: relative;
      .loading-box {
        position: absolute;
        top: 0;
        left: 0;
        height: 110%;
        width: 100%;
        z-index: 50;
      }
      .phone-box {
        position: relative;
      }
    .resend-btn {
      height: 32px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      margin: 0 auto;
      color: #aa0bc0;
      cursor: pointer;
      text-align: center;
      border-radius: 16px;
      transition: all 0.3s ease;
      &:hover:not(.disabled) {
        background: rgba(170, 11, 192, 0.1);
        transform: translateY(-1px);
      }
      &.disabled {
        color: #999;
        cursor: not-allowed;
      }
    }
    }

  }
}

// Cloudflare 弹层样式
.cloudflare-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  
  .cloudflare-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
  }
  
  .cloudflare-content {
    position: relative;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
    max-width: 480px;
    width: 100%;
    max-height: 85vh;
    overflow: hidden;
    animation: modalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    transform-origin: center;
    
    .cloudflare-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px 28px;
      border-bottom: 1px solid #e9ecef;
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      
      h3 {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #2c3e50;
        display: flex;
        align-items: center;
      }
      
      .close-btn {
        background: none;
        border: none;
        font-size: 22px;
        color: #6c757d;
        cursor: pointer;
        padding: 8px;
        border-radius: 8px;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        
        &:hover {
          background: #e9ecef;
          color: #495057;
          transform: scale(1.1);
        }
      }
    }
    
    // Cloudflare 组件容器
    :deep(.cloudflare-verify) {
      padding: 24px 28px 28px;
      text-align: center;
      
      .cloudflare-widget {
        margin: 0 auto;
        border-radius: 8px;
        overflow: hidden;
      }
    }
  }
}

@keyframes modalSlideIn {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(-30px);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05) translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@media screen and (max-width: 950px) {
  .login-box {
    width: 100vw;
    .content-box {
      .back-btn {
        display: none;
      }
      .img-bg {
        zoom: 0.4;
      }
    }
    .form-box {
      width: 94vw;
      padding: 0 0 10px;
      .top-box {
        padding: 10px;
        .close {
          right: 0;
        }
        .back {
          left: 0;
        }
      }
      .slide-box {
        h2 {
          font-size: 18px;
        }
        p {
          font-size: 14px;
        }
        .input-box {
          margin-top: 20px;
          .area-box {
            height: 50px;
          }
          .shadow-box {
            input {
              box-shadow: unset;
              height: 50px;
              width: 90%;
              font-size: 16px;
            }
          }
        }
        .phone-box {
          .sign-btn {
            margin: 20px auto 0!important;
          }
          .resend-btn {
            margin: 10px auto 0!important;
            font-size: 16px;
            padding: 8px 16px;
          }
        }
        .check-box {
          padding-left: 5px;
        }
        
        .login-method-selector {
          margin: 15px 0;
          
          .method-option {
            padding: 12px 15px;
            
            i {
              font-size: 16px;
              margin-right: 6px;
            }
            
            span {
              font-size: 14px;
            }
          }
        }
        
        .account-type-selector {
          margin: 8px auto;
          max-width: 160px;
          display: flex;
          justify-content: center;
          
          .type-option {
            padding: 5px 8px;
            
            i {
              font-size: 10px;
              margin-right: 3px;
            }
            
            span {
              font-size: 10px;
            }
          }
        }
        .ver-code {
          width: 90%!important;
          margin: 20px auto 15px!important;
          position: relative;
          
          input {
            width: 100%!important;
            font-size: 24px;
            height: 50px;
          }
        }
        .sign-btn {
          width: 80%!important;
          margin: 20px auto 0!important;
          height: 48px;
          font-size: 20px;
        }
        .being-send {
          margin: 10px auto 0!important;
        }
        
        .forgot-password-container {
          padding-right: 10px;
          margin-top: 10px;
        }
        
        .forgot-password-link {
          font-size: 13px;
        }
      }
    }
  }
}

</style>
